import { CONTACTOS_CONTRATO_CORPORATIVO,
    CONTACTOS_CREAR_CONTRATO_CORPORATIVO,
    CONTACTOS_CURRENT_CORPORATIVO
} from '../actions/corportativo';

let initialState = {
    esHabilitadoCrearContrato: true,
    current: null,
    contrato: null,
};

const reducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case CONTACTOS_CURRENT_CORPORATIVO:
            return {
                ...state,
                current: payload,
            };
        case CONTACTOS_CONTRATO_CORPORATIVO:
            return {
                ...state,
                contrato: payload,
            };
        case CONTACTOS_CREAR_CONTRATO_CORPORATIVO:
            return {
                ...state,
                esHabilitadoCrearContrato: payload,
            };
        default:
            return {
                ...state
            };
    }
};

export default reducer;
